import { configureStore } from "@reduxjs/toolkit";
import navbarReducer from "./slice/navbarActive/navbarSlice";
import menuReducer from "./slice/menuActive/menuActive";
import selectedMenu from "./slice/selected-menu/selectedMenu.slice";
import tokenReducer from "./slice/token/token.slice";
import profileReducer from "./slice/profileSlice/profile.slice";
import loadingReducer from "./slice/loading/loading.slice";
import fiscalYear from "./slice/fiscal-year/fiscalYear.slice";
import permission from "./slice/permission/permission.slice";

import departmentSlice from "./slice/departmentSlice/department.slice";
import paginationSlice from './slice/pagination/pagination.slice';

const store = configureStore({
  reducer: {
    navbar: navbarReducer,
    menu: menuReducer,
    selectedMenu: selectedMenu,
    token: tokenReducer,
    profile: profileReducer,
    loading: loadingReducer,
    fiscalYear: fiscalYear,
    permission: permission,
    department: departmentSlice,
    pagination:paginationSlice
  },
});

export default store;
